<div class="wells-schema-editor">
    <div class="header">
        <h3>Edit Schema: {{ wellName }} - {{ schemaType }}</h3>
        <button class="close-btn" (click)="close()">×</button>
    </div>

    <div class="content" *ngIf="!isLoading">
        <div class="suggestions-list">
            <div 
                class="suggestion-item" 
                *ngFor="let suggestion of suggestions; trackBy: trackBySuggestion"
                [ngClass]="{ 'modified': suggestion.isModified }">
                
                <div class="field-info">
                    <label>{{ suggestion.field }}</label>
                    <span class="field-type">({{ suggestion.type }})</span>
                </div>

                <div class="value-editors">
                    <div class="original-value">
                        <label>Original:</label>
                        <span>{{ suggestion.originalValue }}</span>
                    </div>

                    <div class="new-value">
                        <label>New Value:</label>
                        <input 
                            type="text"
                            [(ngModel)]="suggestion.currentValue"
                            (ngModelChange)="onValueChange(suggestion, $event)"
                            [placeholder]="suggestion.originalValue"
                            class="form-input">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="footer">
        <div class="error" *ngIf="error">{{ error }}</div>
        
        <div class="actions">
            <button 
                class="btn btn-secondary" 
                (click)="resetChanges()"
                [disabled]="isLoading">
                Reset Changes
            </button>
            
            <button 
                class="btn btn-primary" 
                (click)="saveSuggestions()"
                [disabled]="isLoading || !hasPendingChanges()">
                Save Suggestions
            </button>
        </div>
    </div>

    <sdk-loading [isLoading]="isLoading"></sdk-loading>
</div>
